var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dataOrigin.state === 'done')?_c('div',{staticClass:"done"},[_vm._v("no need")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }